import i18n from "@/i18n";

import { UserInfo } from "@/api/rest/models/account";

import { debug } from "../debug/logger";

import { changeLanguage } from "./changeLanguage";

export const initializeUserLanguage = async (account: UserInfo) => {
  const currentLang = i18n.language || "en";
  const userLang = account.language;

  debug.log(
    "initializeUserLanguage",
    `Attempting to set language. Current: ${currentLang}, User's preference: ${userLang}`,
  );

  if (!userLang) {
    await changeLanguage(currentLang);
    return;
  }

  if (currentLang !== userLang) {
    await i18n.changeLanguage(userLang);
  }
};
